import AddIcon from 'icons/add.svg?react';
import AddBlackIcon from 'icons/add_black.svg?react';
import AiInterviewIcon from 'icons/ai_interview.svg?react';
import ApartmentIcon from 'icons/apartment.svg?react';
import ArrowDownAccordionIcon from 'icons/arrow_down_accordion.svg?react';
import BluePencilIcon from 'icons/blue_pencil.svg?react';
import BuildIcon from 'icons/build.svg?react';
import CheckIcon from 'icons/check.svg?react';
import CheckCircleIcon from 'icons/check_circle.svg?react';
import ChevronIcon from 'icons/chevron.svg?react';
import CopyIcon from 'icons/copy.svg?react';
import DeiIcon from 'icons/dei.svg?react';
import DeleteOutlineIcon from 'icons/delete_outline.svg?react';
import DoneAllIcon from 'icons/done_all.svg?react';
import EmailIcon from 'icons/email.svg?react';
import EmptyIcon from 'icons/empty.svg?react';
import EmptyCompanyIcon from 'icons/empty_company_logo.svg?react';
import ExclamationMarkInCircle from 'icons/exclamation_mark_in_circle.svg?react';
import ExternalLinkIcon from 'icons/external_link.svg?react';
import EyeIcon from 'icons/eye.svg?react';
import FavouriteIcon from 'icons/favourite.svg?react';
import UploadIcon from 'icons/file_upload.svg?react';
import FilterIcon from 'icons/filter.svg?react';
import GroupIcon from 'icons/group.svg?react';
import GroupsIcon from 'icons/groups.svg?react';
import HelpOutlineIcon from 'icons/help_outline.svg?react';
import HideEyeIcon from 'icons/hide_eye.svg?react';
import CloseGrayIcon from 'icons/ic_close_gray.svg?react';
import ExportIcon from 'icons/ic_export.svg?react';
import InductiveIconInCircleColored from 'icons/ic_inductive.svg?react';
import LogoutIcon from 'icons/ic_logout.svg?react';
import NoteIcon from 'icons/ic_note.svg?react';
import NumericalIconInCircleColored from 'icons/ic_numerical.svg?react';
import PersonalityIconInCircleColored from 'icons/ic_personality.svg?react';
import SearchIcon from 'icons/ic_search.svg?react';
import SmallNoteIcon from 'icons/ic_small_note.svg?react';
import VerbalIconInCircleColored from 'icons/ic_verbal.svg?react';
import InfoIcon from 'icons/info.svg?react';
import LanguageIcon from 'icons/language.svg?react';
import LeftArrowIcon from 'icons/left_arrow.svg?react';
import LightbulbIcon from 'icons/lightbulb.svg?react';
import LockIcon from 'icons/lock.svg?react';
import OpenTabIcon from 'icons/open_tab.svg?react';
import PencilIcon from 'icons/pencil.svg?react';
import PencilFull from 'icons/pencil_full.svg?react';
import PlaylistAddCheckIcon from 'icons/playlist_add_check.svg?react';
import PlusIcon from 'icons/plus.svg?react';
import ReplayIcon from 'icons/replay.svg?react';
import SettingsIcon from 'icons/settings.svg?react';
import SkillsSelfAssessmentIcon from 'icons/skills_self_assessment.svg?react';
import SmallDownloadIcon from 'icons/small_download.svg?react';
import SZLogoIcon from 'icons/SpottedZebraLogo.svg?react';
import TagIcon from 'icons/tag.svg?react';
import TimelapseIcon from 'icons/timelapse.svg?react';
import UnarchiveIcon from 'icons/unarchive.svg?react';
import UploadGreyIcon from 'icons/upload_grey.svg?react';
import UploadWhiteIcon from 'icons/upload_white.svg?react';
import WarningIcon from 'icons/warning.svg?react';
import { FC } from 'react';

const iconsObj = {
  add: AddIcon,
  ai_interview: AiInterviewIcon,
  build: BuildIcon,
  check_circle: CheckCircleIcon,
  delete_outline: DeleteOutlineIcon,
  done_all: DoneAllIcon,
  logout: LogoutIcon,
  playlist_add_check: PlaylistAddCheckIcon,
  replay: ReplayIcon,
  sz_logo: SZLogoIcon,
  timelapse: TimelapseIcon,
  add_black: AddBlackIcon,
  left_arrow: LeftArrowIcon,
  check: CheckIcon,
  pencil: PencilIcon,
  bluePencil: BluePencilIcon,
  upload: UploadIcon,
  upload_white: UploadWhiteIcon,
  upload_grey: UploadGreyIcon,
  note: NoteIcon,
  email: EmailIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  chevron: ChevronIcon,
  verbalInCircleColored: VerbalIconInCircleColored,
  numericalInCircleColored: NumericalIconInCircleColored,
  inductiveInCircleColored: InductiveIconInCircleColored,
  personalityInCircleColored: PersonalityIconInCircleColored,
  skills_self_assessment: SkillsSelfAssessmentIcon,
  small_download: SmallDownloadIcon,
  dei: DeiIcon,
  eye: EyeIcon,
  help_outline: HelpOutlineIcon,
  exclamation_mark_in_circle: ExclamationMarkInCircle,
  export_icon: ExportIcon,
  tag: TagIcon,
  filter: FilterIcon,
  copy: CopyIcon,
  info: InfoIcon,
  language: LanguageIcon,
  ic_close_gray: CloseGrayIcon,
  plus: PlusIcon,
  openTab: OpenTabIcon,
  groups: GroupsIcon,
  assessments: SmallNoteIcon,
  empty: EmptyIcon,
  pencil_full: PencilFull,
  group: GroupIcon,
  favourite: FavouriteIcon,
  hide_eye: HideEyeIcon,
  arrow_down_accordion: ArrowDownAccordionIcon,
  empty_company: EmptyCompanyIcon,
  apartment: ApartmentIcon,
  external_link: ExternalLinkIcon,
  warning: WarningIcon,
  lock: LockIcon,
  lightbulb: LightbulbIcon,
  unarchive: UnarchiveIcon,
};

export type IconType = keyof typeof iconsObj;

interface IconProps {
  icon: IconType;
  className?: string;
  id?: string;
}

const Icon: FC<IconProps> = ({ icon, className, id }) => {
  const Component = iconsObj[icon];

  return iconsObj[icon] ? <Component className={className} id={id} /> : null;
};

export default Icon;
